module.exports = __webpack_public_path__ + "static/53-94aee79097f6adff181198b72373db3a.png";